/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { Box, SimpleGrid } from '@chakra-ui/react';
import DriverTable from 'views/admin/driverDetails/components/driverSub/DriverTable';
import { columnsDataComplex } from 'views/admin/driverDetails/variables/columnsData';
import React, { useEffect, useState, useCallback } from 'react';
import UserService from '../../../services/UserService';

export default function Settings() {

  const [error, setError] = useState('');

  const [tableDataComplex, setDriverData] = useState([]);

  const getIncidentData =  useCallback(async () => {
    try {
      const driverData = await UserService.getAllUsers(localStorage.getItem('token'), 'DRIVER');
      if (driverData.status === 201 && driverData.data.object) {

        let err = error;
          if(err){

          }

        const filteredData = driverData.data.object.map(item => {

          return{
            id: item.id,
            name: item.preferredName,
            emailAddress: item.emailAddress,
            mobileNumber: item.mobileNumber,
            role: item.userRole,
            status: item.status,
            options: ''
          };
      });
      setDriverData(filteredData)
      } else {
        setError(driverData.error);
      }
    } catch (error) {
      console.log(error);
      setError(error);
      setTimeout(() => {
        setError('');
      }, 5000);
    }
  }, [error]);

  // eslint-disable-next-line
  useEffect(() => {
    // eslint-disable-next-line
    getIncidentData()
   
  }, [getIncidentData]);

  

  // Chakra Color Mode
  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
         {tableDataComplex && tableDataComplex.length > 0 ? (
        <DriverTable
          columnsData={columnsDataComplex}
          tableData={tableDataComplex}
        />
      ) : (
        <p>No Incidents available</p> // Optional: message when no data is available
      )}
      </SimpleGrid>
    </Box>
  );
}
